import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { EditText } from '../../../../component/ui/edit-text/edit-text';
import { createSecurityGroupOperation } from '../operations/create-security-group-operation';

interface CreateSecurityGroupDialogProps {
  visible: boolean;
  onHide: () => void;
  onCreated: () => void;
}

export const CreateSecurityGroupDialog: React.FC<
  CreateSecurityGroupDialogProps
> = ({ visible, onHide, onCreated }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible) {
      setName('');
      setDescription('');
      setLoading(false);
    }
  }, [visible]);

  const handleSubmit = async () => {
    await createSecurityGroupOperation(
      { name, description },
      setLoading,
      () => {
        onCreated();
        onHide();
      },
    );
  };

  const footer = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '8px',
      }}
    >
      <Button
        label="ביטול"
        icon="pi pi-times"
        onClick={onHide}
        className="p-button-text"
        disabled={loading}
      />
      <Button
        label="שמירה"
        icon="pi pi-check"
        onClick={handleSubmit}
        loading={loading}
        disabled={loading}
      />
    </div>
  );

  return (
    <Dialog
      header="הוספת קבוצת הרשאות חדשה"
      visible={visible}
      onHide={onHide}
      style={{ width: '560px', maxWidth: '95vw' }}
      footer={footer}
      dismissableMask
      draggable={false}
      resizable={false}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          direction: 'rtl',
          paddingTop: '4px',
        }}
      >
        <EditText
          title="שם הקבוצה"
          value={name}
          onChange={setName}
          maxLength={128}
        />

        <div style={{ marginBottom: '16px' }}>
          <label style={{ fontSize: '14px', color: '#4b5563' }}>תיאור</label>
          <InputTextarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={4}
            style={{ width: '100%', marginTop: '4px', resize: 'vertical' }}
            placeholder="תיאור (אופציונלי)"
          />
        </div>
      </div>
    </Dialog>
  );
};
